import React from "react";
import { Gallery4 } from "../../../components/blocks/gallery4";

const demoData = {
  title: "Built for everyone in the ecosystem",
  description:
    "Nesolearn unites learners, educators, institutions, and creators in one verifiable ecosystem for skills, credentials, and opportunity. Explore the platform built for where you fit in.",
  items: [
        {
      id: "for-learners",
      title: "For Learners",
      description:
        "Build real skills, earn portable credentials, and own an identity that carries your progress with you, verifiable and yours for good.",
      cta: "Start Learning",
      href: "/for-individuals",
            image:
        "https://images.unsplash.com/photo-1758270705317-3ef6142d306f?q=80&w=1200",
    },
        {
      id: "for-institutions",
      title: "For Institutions",
      description:
        "Issue, track, and certify your programs on infrastructure built for verification, reducing certificate fraud and giving every graduate a credential that holds up anywhere.",
      cta: "Request a Demo",
      href: "/for-institutions",
      image:
        "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/8293649e-ca48-4a44-b32c-7838577835c9_removalai_preview.png",
    },
        {
      id: "nesolearn-kids",
      title: "Nesolearn Kids",
      description:
        "A safe, age-appropriate learning experience built for younger learners to explore skills early. Coming soon.",
      cta: "Get Notified",
      href: "/nesolearn-kids",
            image:
        "https://pub-b365ff8e20e448c3a7257b35173d9a38.r2.dev/mockups%20nesolearn/curios.png",
    },
        {
      id: "for-educators",
      title: "For Educators",
      description:
        "Real training and capacity building for educators, with tools to build, teach, and grow your own courses. Coming soon.",
      cta: "Join the Waitlist",
      href: "#",
            image:
        "https://images.unsplash.com/photo-1758685848142-06e158cf64bc?q=80&w=1200",
    },
        {
      id: "for-creators",
      title: "For Creators",
      description:
        "Build a course once and keep it forever. Every time it helps someone, you get paid for it. Coming soon.",
      cta: "Join the Waitlist",
      href: "#",
            image:
        "https://images.unsplash.com/photo-1611784728558-6c7d9b409cdf?q=80&w=1200",
    },
        {
      id: "visioneer",
      title: "Visioneer",
      description:
        "Mentorship, built into the way you learn. Connect with real builders, founders, engineers, and creators who've already done what you're working toward.",
      cta: "Meet Your Mentor",
      href: "/visioneer",
            image:
        "https://cdn.prod.website-files.com/671752cd4027f01b1b8f1c7f/6717795bb5aceca85011ad83_osmo-parallax-layer-1.webp",
    },
  ],
};

export default function ProjectsSection() {
  return <Gallery4 {...demoData} />;
}